import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ComponentRendering,
  JssModule,
  RichTextField,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { FormState } from 'ngrx-forms';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { GenericRichTextDirective } from '@core/jss-utils';

import { ToggleComponent } from '../toggle/toggle.component';

@Component({
  selector: 'wl-toggle-with-info[rendering]',
  templateUrl: './toggle-with-info.component.html',
  styleUrls: ['./toggle-with-info.component.ed.scss'],
  standalone: true,
  imports: [
    JssModule,
    CommonUiUtilityComponentsModule,
    ToggleComponent,
    GenericRichTextDirective,
  ],
})
export class ToggleWithInfoComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: ComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() description?: RichTextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() containerClass?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formControl?: FormState<boolean>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() checked = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() toggleId?: string;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = new EventEmitter<Event>();

  get isChecked() {
    return this.formControl?.value ?? this.checked;
  }

  get elementId() {
    return this.formControl?.id ?? this.toggleId ?? '';
  }

  onToggle(event: Event) {
    this.toggle.emit(event);
  }
}
